import { render, staticRenderFns } from "./sealReceive.vue?vue&type=template&id=7a27f37c&"
import script from "./sealReceive.vue?vue&type=script&lang=js&"
export * from "./sealReceive.vue?vue&type=script&lang=js&"
import style0 from "./sealReceive.vue?vue&type=style&index=0&id=7a27f37c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports